const initialState = {
  permissionsList: [],
  addPermissions: [],
  isFetchingPermissionsList: false,
  isAddingPermissions: false
};

const permissionReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_ADD_PERMISSIONS":
      return { ...state, isAddingPermissions: true };
    case "SUCCESS_ADD_PERMISSIONS":
      return { ...state, addPermissions: action.payload, isAddingPermissions: false }
    case "ERROR_ADD_PERMISSIONS":
      return { ...state, isAddingPermissions: false };


    case "REQUEST_GET_PERMISSIONS":
      return { ...state, isFetchingPermissionsList: true };
    case "SUCCESS_GET_PERMISSIONS":
      return { ...state, permissionsList: action.payload, isFetchingPermissionsList: false }
    case "ERROR_GET_PERMISSIONS":
      return { ...state, isFetchingPermissionsList: false };


    default:
      return state;
  }

}
export default permissionReducer;

